<div class="header">
  <h1 class="skills-header-text">
    {{ 'label.Skills' | translate }}
  </h1>
</div>
<div class="container">
  <div
    class="skills"
  >
    <div class="skills-info">
      <div class="skill-group" [ngClass]="{ 'changed-label': hasHardSkillChanges && isEdited }">
        <div class="label-with-reject-button">
          <span class="skill-group-title">
            {{ 'label.HardSkills' | translate }}
          </span>
          <app-reject-dialog
            *ngIf="hasHardSkillChanges && isEdited"
            [id]="jobseekerEnum.HardSkill"
            (setDictionary)="rejectHardSkills($event)"
          ></app-reject-dialog>
        </div>
        <div class="skill-chips">
          @for (skill of hardSkills; track skill.index) {
          <div
            class="skill-chip"
            [ngClass]="{ 'skill-chip--custom': isCustom(skill) }"
          >
            @if (isAdded(skill, hardSkillChanges) && isEdited) {
            <span class="skill-chip__new-badge">{{'label.NewBadge' | translate}}</span>
            }
            <span class="skill-chip__name">{{ skillName(skill) }}</span>
          </div>
          } @if (isEdited) { @for (skill of removedHardSkills; track
          skill.index) {
          <div class="skill-chip skill-chip--removed">
            <span class="skill-chip__name">
              {{ removedSkillName(skill) }}
            </span>
          </div>
          } } @if (showHardSkillsPlaceholder) {
          <div class="skill-chip skill-chip--placeholder"></div>
          <div class="skill-chip skill-chip--placeholder"></div>
          <div class="skill-chip skill-chip--placeholder"></div>
          }
        </div>
      </div>
      <div class="skill-group" [ngClass]="{ 'changed-label': hasSoftSkillChanges && isEdited }">
        <div class="label-with-reject-button">
          <span class="skill-group-title">
            {{ 'label.SoftSkills' | translate }}
          </span>
          <app-reject-dialog
            *ngIf="hasSoftSkillChanges && isEdited"
            [id]="jobseekerEnum.SoftSkill"
            (setDictionary)="rejectSoftSkills($event)"
          ></app-reject-dialog>
        </div>
        <div class="skill-chips">
          @for (skill of softSkills; track skill.index) {
          <div
            class="skill-chip"
            [ngClass]="{ 'skill-chip--custom': isCustom(skill) }"
          >
            @if (isAdded(skill, softSkillChanges) && isEdited) {
            <span class="skill-chip__new-badge">{{'label.NewBadge' | translate}}</span>
            }
            <span class="skill-chip__name">{{ skillName(skill) }}</span>
          </div>
          } @if (isEdited) { @for (skill of removedSoftSkills; track
          skill.index) {
          <div class="skill-chip skill-chip--removed">
            <span class="skill-chip__name">
              {{ removedSkillName(skill) }}
            </span>
          </div>
          } } @if (showSoftSkillsPlaceholder) {
          <div class="skill-chip skill-chip--placeholder"></div>
          <div class="skill-chip skill-chip--placeholder"></div>
          <div class="skill-chip skill-chip--placeholder"></div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
